import React from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from 'ui/layout/Layout'
import { AppBarPatient } from 'ui/partials/AppBar'
import { H2, Text1 } from 'ui/shorthands/Texts'
import CenteredContainer from 'ui/layout/CenteredContainer'
import type { MedicalInstitutionProps } from 'types/applicant'

export type ReceptionCapacityErrorProps = {
  med?: MedicalInstitutionProps
}

const ReservationVCNotPrepared: React.FC<ReceptionCapacityErrorProps> = ({
  med,
}: ReceptionCapacityErrorProps) => {
  const { t } = useTranslation()
  return (
    <Layout header={<AppBarPatient>{med?.name}</AppBarPatient>} showFooter>
      <CenteredContainer
        header={
          <H2>{t('予約日時の15分前からビデオ通話をご利用いただけます')}</H2>
        }
      >
        <Text1>
          {t(
            'この画面を閉じ、時間になったら再度ビデオ通話を開始してください。'
          )}
        </Text1>
      </CenteredContainer>
    </Layout>
  )
}

export default ReservationVCNotPrepared
